// TODO: aov3-8283 fix circular dependency issue
// eslint-disable-next-line import/no-cycle
import { useAssortmentCanvasStore } from '@/stores/assortment-canvas';
import { useClusteringStore } from '@/stores/clustering';
import { useCompoundExtractStore } from '@/stores/compound-extract';
import { useExtractsStore } from '@/stores/extracts';
import { useFurnitureStore } from '@/stores/furniture';
import { useProductRegionsStore } from '@/stores/product-regions';
import { useScenarioCdtsStore } from '@/stores/scenario-cdts';
import { useScenariosStore } from '@/stores/scenarios';
import { useSimpleSwapRunsStore } from '@/stores/simple-swap-runs';
import { useWorkpackagesStore } from '@/stores/workpackages';
import asynchronousFunctions from '@enums/asynchronous-functions';
import { get } from 'lodash';
import { defineStore } from 'pinia';

export const useJobsStore = defineStore('jobs', () => {
  const getActionName = name => {
    /* The asynchronous-functions enum is shared between Vue3 and Vue2, but the view file is Vue2 compatible.
    Each action defined follows `<vuexStoreName>/<vuexStoreAction>`, so we extract the action part out of it.
    Once Vue2 is depreciated, we can remove this and just update the action name.
    */

    const [vuexStoreName, actionName] = name.split('/');

    return actionName || vuexStoreName;
  };

  const handleJobEventMessage = ({ message }) => {
    const workpackagesStore = useWorkpackagesStore();
    const scenariosStore = useScenariosStore();
    const compoundExtractStore = useCompoundExtractStore();
    const clusteringStore = useClusteringStore();
    const productRegionsStore = useProductRegionsStore();
    const furnitureStore = useFurnitureStore();
    const assortmentCanvasStore = useAssortmentCanvasStore();
    const cdtStore = useScenarioCdtsStore();
    const extractsStore = useExtractsStore();
    const simpleSwapRunsStore = useSimpleSwapRunsStore();

    const jobTypeStoreToUpdateMap = {
      WorkpackageSetup: workpackagesStore,
      SpacebreakGenerator: furnitureStore,
      CdtGeneration: cdtStore,
      ClusteringGenerator: clusteringStore,
      ClusteredSwitching: clusteringStore,
      RegionsByAttributeGenerator: productRegionsStore,
      CanvasGeneration: assortmentCanvasStore,
      AssortmentOptimisation: assortmentCanvasStore,
      Forecaster: assortmentCanvasStore,
      ClScSwitchingMatricesCalculation: assortmentCanvasStore,
      StoreExecutionExtracts: extractsStore,
      ExtractsGeneration: extractsStore,
      FurnitureExtract: extractsStore,
      CopyScenario: scenariosStore,
      CopyWorkpackage: workpackagesStore,
      PrepareSwaps: scenariosStore,
      SimpleSwaps: simpleSwapRunsStore,
      CompoundExtract: compoundExtractStore,
      SetupProductModelling: scenariosStore,
    };

    const { status, jobType } = message;

    //  See if a function exists for this type of message
    const actions = get(asynchronousFunctions.functions, [jobType, 'actions', status]);
    if (actions) {
      //  Dispatch the action
      if (Array.isArray(actions)) {
        actions.forEach(action =>
          jobTypeStoreToUpdateMap[jobType][getActionName(action)]({ message })
        );
      } else {
        jobTypeStoreToUpdateMap[jobType][getActionName(actions)]({ message });
      }
    }
  };

  return { handleJobEventMessage };
});
